import omit from 'lodash/omit';
import createApiClient from 'src/modules/seek-jobs-api-client';
import type { ChaliceStore, TypedAction, TypedThunkAction } from '../reducer';
import { selectIsSrp } from '../selectors';
import { selectJobDetailsResult } from '../jobdetails/jobdetails';
import { getRoleIdFromResults } from '../results/resultsHelpers';

const api = createApiClient();

export const GET_LMIS_SUCCESS = 'GET_LMIS_SUCCESS';
export const GET_LMIS_ERROR = 'GET_LMIS_ERROR';
export const RESET_JDP_LMIS = 'RESET_JDP_LMIS';

export enum pageKeys {
  SRP = 'SRP',
  JDP = 'JDP',
}

const omittedlmisSearchParams = [
  'page',
  'advertiserid',
  'advertisergroup',
  'sortmode',
  'daterange',
];
// Fix me
export type LmisType = 'contextual' | 'generic' | 'fallback';
export interface Lmis {
  content?: string;
  lmisResultType?: LmisType;
  lmisEntity?: string;
  lmisSnippet?: Record<string, string>;
}

export interface LmisState {
  SRP: Lmis;
  JDP: Lmis;
}

interface LmisSuccessAction {
  type: typeof GET_LMIS_SUCCESS;
  payload: {
    content?: string;
    lmisSnippet?: Record<string, string> | null;
    key: string;
  };
}

export type Action =
  | LmisSuccessAction
  | {
      type: typeof RESET_JDP_LMIS;
    }
  | {
      type: typeof GET_LMIS_ERROR;
      payload: { key: string };
    };

const initialItemState = {
  content: '',
  lmisSnippet: undefined,
};

export const initialState = {
  [pageKeys.SRP]: initialItemState,
  [pageKeys.JDP]: initialItemState,
};

export default function reducer(
  state: LmisState = initialState,
  action: TypedAction,
): LmisState {
  switch (action.type) {
    case RESET_JDP_LMIS: {
      return {
        ...state,
        [pageKeys.JDP]: initialItemState,
      };
    }
    case GET_LMIS_SUCCESS: {
      const { key } = action.payload;
      return {
        ...state,
        [key]: action.payload,
      };
    }

    case GET_LMIS_ERROR: {
      const { key } = action.payload;
      return {
        ...state,
        [key]: initialItemState,
      };
    }

    default:
      return state;
  }
}

export const getSerpLmis =
  (options?: { placement: string }): TypedThunkAction =>
  (dispatch, getState) => {
    const placement = options?.placement ?? '90ae91';
    const {
      search,
      location,
      user: { authenticated, seekerId, testHeaders },
      results,
    } = getState();
    const roleId = getRoleIdFromResults(results);

    const searchParams = omit(search.query, omittedlmisSearchParams);

    const lmisParams = {
      placement,
      location: location.country,
      loggedin: authenticated === true,
      candidateId: seekerId,
      roleId,
      ...searchParams,
    };
    return api.lmis
      .getLmis({
        lmisParams,
        requestId: location.requestId,
        testHeaders,
      })
      .then((response: any) =>
        dispatch({
          type: GET_LMIS_SUCCESS,
          payload: { ...response, key: pageKeys.SRP },
        }),
      )
      .catch((err: Error) =>
        dispatch({
          type: GET_LMIS_ERROR,
          payload: {
            err,
            key: pageKeys.SRP,
          },
        }),
      );
  };

export const selectLmis = (state: ChaliceStore) => {
  const lmisKey =
    selectIsSrp(state) && !selectJobDetailsResult(state)
      ? pageKeys.SRP
      : pageKeys.JDP;

  return state.lmis[lmisKey];
};
